/**
 * @section 4.2.1.6
 */
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialSwitch from "@material-ui/core/Switch";
import { excludeKeys } from "./../utils";
const useStylesForLanguageSwitch = makeThemedStyles(
  "LanguageSwitch",
  (theme) => ({
    LanguageSwitch: {},
  })
);
type PropType = React.ComponentProps<typeof MaterialSwitch>;
export const LanguageSwitch: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForLanguageSwitch();
  const enabledClasses = excludeKeys(styles, ["LanguageSwitch"]);
  /* eslint-disable */
  return (
    <MaterialSwitch
      {...props}
      classes={{
        root: styles.LanguageSwitch,
        ...enabledClasses,
      }}
      className={clsx(styles.LanguageSwitch)}
    ></MaterialSwitch>
  );
};
export default LanguageSwitch;
